// this takes a list of elements and applies a single function or list of functions each element of the list
// this is a bit of functional programming that simplifies your code if you're doing lots of
// transformations on elements of your list
function applyFunctionsToElements(elements, callbacks = []) {
  let newArr = [];
  if (callbacks.constructor !== Array) callbacks = [callbacks];
  if (elements.constructor !== Array) elements = [elements];
  const applyCallbackToElements = el => callbacks.map(callback => callback(el))[0];
  newArr = elements.map(obj => applyCallbackToElements(obj));
  return newArr;
}
function runOnce(context, fn, args) {
  // TODO: make this function available for multiple functions
  runOnce = () => {};
  context = context || this;
  fn.apply(context, args);
}
function isJqueryEl(el) {
  // Boolean.  Answers the Q of is this a jQuery element
  return 'jquery' in Object(el) ? true : false;
}
function changePageTitle(new_title, duration = 1000) {
  const original_page_title = document.title;
  document.title = new_title;
  setTimeout(() => document.title = original_page_title, duration);
}
function formatNumberByThree(num, separator = ',') {
  // 100000 -> '100,000'
  // format number to insert back into DOM
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}
function removeCommasFromNumber(num) {
  // '100,000' -> 100000
  return parseFloat(num.toString().replace(/,/g, ''));
}
function roundUpToWholeNumber(num) {
  // 99.941 -> 100
  return Math.ceil(num);
}

/** calculatePaymentDecimal - calculate loan EMI, rounds up to whole number
 * @param  loan amount, rate, term in months
 *
 */
function calculateMonthlyPayment(loanAmount, rate, term) {
  // check for 0 or no loan amount
  if (!loanAmount) return 0;

  // remove comma from loan amount value and parse to decimal
  const principle = removeCommasFromNumber(loanAmount);
  // format rate
  const intr = parseFloat(rate) / 1200;
  // calculate monthly payment and round up to next whole number

  let payment;

  // if intr is 0, then just divide principle to term
  if (!intr) {
    payment = roundUpToWholeNumber(principle / term);
  } else {
    payment = roundUpToWholeNumber(principle * intr / (1 - Math.pow(1 / (1 + intr), term)));
  }

  //update view to show monthly payment
  return addCommasToNumber(payment);
}

// Sparta adds body classes to the page.  This will return the t-shirt size of your screen from those added classes.
function getPageSize() {
  const bodyClassList = document.querySelector('body').classList;
  const small = [...bodyClassList].indexOf('small-only') > -1 && 'small';
  const medium = [...bodyClassList].indexOf('medium-only') > -1 && 'medium';
  const large = [...bodyClassList].indexOf('large') > -1 && 'large';
  return small || medium || large;
}
function prefixen() {
  return ["webkit", "moz", "MS", "o", ""];
}

// give it an event and this returns your browsers prefixed event names
function prefixedEventName(event) {
  const fakeEl = document.createElement('fakeelement');
  let eventName = event.toLowerCase();
  prefixen().some(prefix => {
    if (fakeEl.style[prefix + event] !== undefined) {
      eventName = prefix + event;
      return true; // break out of loop
    } else {
      return true; // break out of loop
    }
  });
  return eventName;
}

// you have a module who needs internal pub/sub but Sparta events is a lot for the little you're trying to do
// use lilPubSub for a tiny implementation of the pattern
const lilPubSub = (() => {
  const events = {};
  return {
    sub: function sub(title, cb) {
      // subscribe - lilPubSub.sub('your_event', someCallBack.bind(this));
      name = title;
      events[title] = cb;
    },
    pub: function pub(title, ...args) {
      // publish - lilPubSub.pub('your_event', arg1, arg2);
      if (Object.prototype.hasOwnProperty.call(events, title)) {
        events[title](...args);
      }
    }
  };
})();

/**
 * In the event (pun intended) that you wish to add a condition to your event handler...
 * @param {Function} conditionalFn that you want to call before executing the callback handler
 * @param {Function} callback the thing you do when your condition is passed
 * @returns {Function} an annonymous function returned to your event handler
 */
const delegateEventWhen = (conditionalFn, callback) => {
  return event => {
    if (conditionalFn(event)) return callback(event);
  };
};

// output: a closure that keeps track of the product number.
// If 0 -> return empty string if you don't want to use only natural numbers.
// I hope you know what a natural number is...
function genericCounter(onlyNaturalNumbers = false) {
  let n = 0;
  function counter(num) {
    n = num ? n + num : n;
    const defaultNumber = onlyNaturalNumbers ? '' : n;
    return n < 1 ? defaultNumber : n;
  }
  counter.reset = () => n = 0;
  return counter;
}

/**
 * Returns an object that gives the scroll or page offset for both IE and non-IE browsers.
 * @returns {Object} with corresponding X and Y positions as numbers.
 */
function scrollOffset() {
  return {
    x: window.scrollX || window.pageXOffset,
    y: window.scrollY || window.pageYOffset
  };
}

/**
 * Make your code popout of the queue stack
 * @returns {Undefined} the execution of a function.  If it has a return value, you'll receive it.
 */
function setAsync(callback, ...args) {
  setTimeout(() => {
    return callback.call(null, ...args);
  }, 0);
}

/**
 * Basic ES6 debounce function stolen from the interwebs
 * @param {Function} fn that you want to call
 * @param {Number} time the duration of time you want the function called
 * @returns {Function} a closure that calls the function after a duration
 */
function debounce(fn, time) {
  let timeout;
  return function () {
    const functionCall = () => fn.apply(this, arguments);
    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
}

/**
 * Creates a simple window resize event listener with debounce
 * @param {Function} fn that you want to call
 * @param {Number} time the duration of time you want the function called
 * @returns {Undefined}
 */
function windowResizeListener(fn, time) {
  window.addEventListener('resize', () => debounce(fn(), time));
}

/**
 * Runs a callback if the page size changes above or below a threshold
 * @param {Number} threshold the page width size in pixels you wish to react to
 * @param {Function} fn that you want to call
 * @param {Number} time the duration of time you want the function called
 * @param {Boolean} runByDefault will run your callback once to kickstart
 * @returns {Undefined}
 */
function runIfPageSizeChange(threshold, callback, options = {}) {
  const config = Object.assign({
    runAtInit: false,
    time: 350
  }, options);
  const {
    runAtInit,
    time
  } = config;
  let lastSize = window.innerWidth;
  const isAboveThreshold = num => num >= threshold;
  const sizeTest = () => {
    const currentSize = window.innerWidth;
    const isAbove = isAboveThreshold(currentSize);
    if (isAbove && lastSize < threshold || !isAbove && lastSize >= threshold) {
      callback(isAbove);
      lastSize = currentSize;
    }
  };
  if (runAtInit) callback(isAboveThreshold(lastSize));
  windowResizeListener(sizeTest.bind(this), time);
}

/**
 * Create a delay that's easy to use with async/await
 * @param {Number} delay time you want to wait as a delay
 * @param {*} args whatever is being passed to the setTimeout
 * @returns {Object} a new promise
 * @example  const startAnim = async () => { await delay(100); doStuff(); };
 */
const delay = (delay, ...args) => new Promise(resolve => setTimeout(resolve, delay, ...args));

/**
 * Create a synchronous promise chain
 * @param {*} args of Promises
 * @returns {Array} an array of the resolved Promises
 * @example  promiseSequence(myPromise1, myPromise2).then(myResults => console.log(myResults));
 */
const promiseSequence = (...promises) => {
  return promises.reduce((promiseChain, currentTask) => {
    // sequential resolution
    return promiseChain.then(chainResults => currentTask.then(currentResult => [...chainResults, currentResult]));
  }, Promise.resolve([]));
};

/**
 * Get whatever parameter you're looking for out of the URL
 * @param {String} query that you want to search as the key
 * @returns {String} the value of what you're searching
 */
const getUrlParams = (query => {
  if (!query) return {};
  return (/^[?#]/.test(query) ? query.slice(1) : query).reduce((params, param) => {
    let [key, value] = param.split('=');
    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {});
})(window.location.search.substr(1).split('&'));

/**
 * Get a report of the number of event listeners on a given page
 * @returns {Object} the breakdown of event listeners
 */
function getEventListenersReport() {
  return Array.from(document.querySelectorAll('*')).reduce((report, dom) => {
    const eventObj = getEventListeners(dom);
    Object.keys(eventObj).forEach(event => {
      if (typeof report[event] === 'undefined') {
        report[event] = 0;
      }
      report[event] += eventObj[event].length;
    });
    return report;
  }, {});
}
function showActiveElement(outlineStr = '1px solid rgba(81, 203, 238, 1)') {
  const wasActive = [];
  return () => {
    const activeEl = document.activeElement;
    if (wasActive.indexOf(activeEl) > -1) {
      console.warn('El is keeping the focus for itself: ', activeEl);
      return;
    }
    if (wasActive.length) wasActive[0].style.outline = null;
    wasActive.length = 0;
    console.log('active el: ', activeEl);
    wasActive.push(activeEl);
    activeEl.style.outline = outlineStr;
  };
}
function showActive(byKey) {
  const showActive = showActiveElement();
  const legend = {
    tab: 9
  }; // TODO: add more button keys to the legend obj

  document.addEventListener('keyup', e => {
    if (e.keyCode === legend[byKey]) return showActive();
    showActive();
  }, false);
}

export { applyFunctionsToElements, calculateMonthlyPayment, changePageTitle, debounce, delay, delegateEventWhen, formatNumberByThree, genericCounter, getEventListenersReport, getPageSize, getUrlParams, isJqueryEl, lilPubSub, prefixedEventName, prefixen, promiseSequence, removeCommasFromNumber, roundUpToWholeNumber, runIfPageSizeChange, runOnce, scrollOffset, setAsync, showActive, windowResizeListener };
